import { render, staticRenderFns } from "./SystemConfigurationList.vue?vue&type=template&id=48ebd441&"
import script from "./SystemConfigurationList.vue?vue&type=script&lang=js&"
export * from "./SystemConfigurationList.vue?vue&type=script&lang=js&"
import style0 from "./SystemConfigurationList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports